import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fullScreenLoadingAction } from '../redux/slices/fullSrceenLoadingSlice';

const useFullScreenLoading = () => {
    const dispatch = useAppDispatch();
    const fullScreenLoadingStates = useAppSelector(
        (state) => state.fullScreenLoading.isLoading
    );

    const setFullScreenLoading = (isLoading: boolean) => {
        dispatch(
            fullScreenLoadingAction.setIsLoading(isLoading)
        );
    };

    return {
        fullScreenLoadingStates,
        setFullScreenLoading
    };
};

export default useFullScreenLoading;
